import axios from "axios";
import apiUrl from "../../Apiurl";
import apriUrl from "../../interfaccia/funzioniComuni/apriUrl";

const stampaFormatoATTESE = async function(token,ordiniSelezionati,idPreCompilati,tipoStampa,vista) {
    if (!token) {
        console.warn("sto aspettando un token")
        return;
    }
    let idOrdini;
    try {
        if (idPreCompilati) {
            idOrdini = ordiniSelezionati;
        } else {
            if (vista === "articoli") {
                idOrdini = [...new Set(ordiniSelezionati.map(ord => ord.idSped))]; // Garantisce valori univoci
            } else if (!vista || vista === "ordini") {
                idOrdini = ordiniSelezionati.map(ord => ord.id);
            }
        }
    } catch (err) {
        console.log("Errore nella creazione array ID ordini: " + err)
        throw err;
    }
    console.log(idOrdini);
    try {
        const data = {
            idOrdini: idOrdini
        }
        const config = {
            headers: {
                'Authorization': 'Bearer ' + token,
            },
        }
        let url = "/logistica/pdf/ordiniByID"
        if (tipoStampa === "controllo") {
            url = "/logistica/pdf/listaControllo"
        }
        if (tipoStampa === "prelievo") {
            url = "/logistica/pdf/listaPrelievo"
        }
        if (tipoStampa === "prelievoDatiCliente") {
            url = "/logistica/pdf/listaPrelievoDettagliato"
        }
        axios.post(apiUrl + url, data, config)
            .then(data => apriUrl(data.data))
    } catch (err) {
        console.log("Errore nell'invio degli ordini alle API': " + err)
        throw err;
    }
};

export default stampaFormatoATTESE;
